module.exports = __webpack_public_path__ + "img/chart-bar.7892e59e.svg";